import type {
  IBynderImage,
  IBynderThumbnails
} from "~/types/contentful/IBynderImage";

function isGif(image: IBynderImage): boolean {
  return image.extension.includes("gif") && image.original !== null;
}

/**
 *
 * @param image This function returns the field src of the image by default.
 * @returns
 */
function getBynderImageUrl(
  image: IBynderImage,
  thumbnail?: keyof IBynderThumbnails
): string {
  if (isGif(image)) return image.original;

  if (thumbnail) {
    return image.thumbnails[thumbnail] || image.src;
  }
  return image.src;
}

export { getBynderImageUrl };
